var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#231F20",
    cx: 44,
    cy: 60,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#231F20",
    cx: 28,
    cy: 60,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.246,21.66C62.492,20.617,61.285,20,60,20H18.977L15.934,3.285C15.59,1.383,13.934,0,12,0H4 C1.789,0,0,1.789,0,4s1.789,4,4,4h4.66l7.406,40.715C16.41,50.617,18.066,52,20,52h32c1.723,0,3.25-1.102,3.793-2.734l8-24 C64.203,24.047,63.996,22.703,63.246,21.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo31);
export default __webpack_public_path__ + "static/media/logo (31).94d6865656bebba0cc29a05c94d724ba.svg";
export { ForwardRef as ReactComponent };